import React from 'react';
import styled from 'styled-components';
import wordmark from '@99designs/frontend-components/core/images/99designs-byVP-wordmark-blue.svg';

const StyledWordmark = styled.div`
    display: inline-block;
    text-align: center;
    width: 120px;
    height: 40px;
`;

export function Wordmark() {
    return (
        <StyledWordmark
            dangerouslySetInnerHTML={{
                __html: wordmark,
            }}
            aria-label={__('99designs by Vistaprint')}
        />
    );
}
